import { render, staticRenderFns } from "./MiniSmoothArea.vue?vue&type=template&id=1cd0b9b6&scoped=true"
import script from "./MiniSmoothArea.vue?vue&type=script&lang=js"
export * from "./MiniSmoothArea.vue?vue&type=script&lang=js"
import style0 from "./MiniSmoothArea.vue?vue&type=style&index=0&id=1cd0b9b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0b9b6",
  null
  
)

export default component.exports